module.exports = __webpack_public_path__ + "img/1.4787f635.jpg";